import useAsyncData from "../../../../hooks/use-async-data";
import cargoCompanyService from "../../cargo-company.service";
import CargoCompanyAddressList from "./cargo-company-address-list";
import CargoCompanyAddressListParams from "./cargo-company-address-list-params";

const useCargoCompanyAddressList = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<CargoCompanyAddressList>([], false);

  const load = async (
    params: CargoCompanyAddressListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoCompanyAddressList = await cargoCompanyService.getAddressList(
        params,
        signal,
      );

      setData(cargoCompanyAddressList);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useCargoCompanyAddressList;
